// Copyright (c) 2017 Deere & Company

import SubClaimTypes, {getDefaultState as getSubClaimTypesDefaultState} from '../../shared/state/sub-claim-types';
import actions from '../../shared/actions-list';

const updateSubClaimTypes = (state, action) =>
    SubClaimTypes.update(state, {
        $set: action.data
    });

export default (state = getSubClaimTypesDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_SUB_CLAIM_TYPES]: updateSubClaimTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/app/reducers/sub-claim-types.js